import { DialogLike } from "@obg/mat.ui.core";

import { MultiSessionLimitConfirmationComponent } from "./multi-session-limit-confirmation.component";
import { MULTI_SESSION_LIMIT_DIALOG_ID } from "./multi-session-limit-confirmation.model";

export const MULTI_SESSION_LIMIT_DIALOG: DialogLike<MultiSessionLimitConfirmationComponent> = {
	dialogId: MULTI_SESSION_LIMIT_DIALOG_ID,
	dialogComponentType: MultiSessionLimitConfirmationComponent,
};
